import {AnchorPriceRateBreakdown} from '@daedalus/core/src/offer/business/offersMapping'
import {OfferPrice} from '@daedalus/core/src/offer/types/offer'
import PriceTypes from '@daedalus/core/src/offer/types/PriceTypes'
import {TaxDisplayLogic} from '@daedalus/core/src/offer/types/TaxDisplayLogic'
import {RateBreakdown} from '@findhotel/sapi'

import {
  calculateNightlyPrice,
  getRaaOrSapiNightlyDisplayTotalPrice
} from './price'

const getIsSapiRateBreakdown = (
  rateBreakdown: RateBreakdown | AnchorPriceRateBreakdown
): rateBreakdown is RateBreakdown => {
  return Boolean((rateBreakdown as RateBreakdown)?.base)
}

const unifyRateBreakdown = (
  rateBreakdown: RateBreakdown | AnchorPriceRateBreakdown
): RateBreakdown => {
  const isSapiRateBreakdown = getIsSapiRateBreakdown(rateBreakdown)

  return isSapiRateBreakdown
    ? rateBreakdown
    : {
        ...rateBreakdown,
        base: rateBreakdown.baseRate,
        hotelFees: rateBreakdown.localTaxes
      }
}

export const adaptSapiPriceToChargeablePrice = (
  rateBreakdown: RateBreakdown | AnchorPriceRateBreakdown,
  taxDisplayLogic: TaxDisplayLogic,
  currencyCode: string,
  numberOfNights: number,
  numberOfRooms: number
): OfferPrice => {
  const {base, taxes, hotelFees} = unifyRateBreakdown(rateBreakdown)

  const nightlyBase = calculateNightlyPrice(base, numberOfNights, numberOfRooms)

  const nightlyTaxes = calculateNightlyPrice(
    taxes,
    numberOfNights,
    numberOfRooms
  )

  const nightlyDisplayTotal =
    taxDisplayLogic &&
    getRaaOrSapiNightlyDisplayTotalPrice(
      base,
      taxes,
      hotelFees,
      numberOfNights,
      numberOfRooms,
      taxDisplayLogic
    )

  const hotelFeesInNumberFormat = {
    nightly: Number(
      calculateNightlyPrice(hotelFees, numberOfNights, numberOfRooms)
    ),
    total: hotelFees
  }

  const chargeableInNumberFormat = {
    base: base,
    nightlyBase: Number(nightlyBase),
    nightlyDisplayTotal,
    nightlyTaxes: Number(nightlyTaxes),
    taxes
  }

  return {
    chargeable: chargeableInNumberFormat,
    currencyCode,
    hotelFees: hotelFeesInNumberFormat,
    type: PriceTypes.CHARGEABLE_PRICE
  }
}
